import { useFormContext } from 'react-hook-form';
import { CopyAssistButtonDropdown } from 'modules/ai/copyAssist/CopyAssistButtonDropdown';
import { CopyAssistTagNames } from 'modules/domains/copyAssist/copyAssist';
import { dataTestId as dataTest } from 'modules/experiments/constants';
import { useCopyAssistContext } from 'modules/experiments/contexts';
import { CopyAssistTextFormFieldProps } from 'modules/experiments/types';
import { StyledVariantFormField } from 'modules/experiments/components/pages/edit/sections/variant_configuration/CommonStyled';
import { InputField } from 'lib/iterable-hook-form';
import { ReadOnlyValue } from '../ReadOnlyValue';
import { StyledCopyAssistWrapper } from './Styled';

export const CopyAssistTextBox = ({
  dataTestId,
  dataKey,
  isFieldEditable,
  isFieldFocused = false,
  fieldLabel,
  fieldName,
  fieldValue,
  helperText,
  contentType,
  messageMedium,
}: CopyAssistTextFormFieldProps) => {
  const { getValues, setValue } = useFormContext();
  const {
    activateCopyAssist,
    activatedFormField,
    copyAssistFormState = {},
  } = useCopyAssistContext();

  return (
    <StyledVariantFormField
      data-test={`${dataTest.copyAssistField}-${dataTestId}`}
      ref={copyAssistFormState?.[dataKey]?.formFieldWrapperRef}
      labelText={fieldLabel}
      helpText={isFieldEditable ? helperText : null}
      isHorizontalLayout
    >
      {isFieldEditable ? (
        <StyledCopyAssistWrapper>
          <InputField
            inputWrapperRef={copyAssistFormState?.[dataKey]?.formFieldRef}
            name={fieldName}
            onFocus={() => activateCopyAssist(fieldName, dataKey)}
            autoFocus={isFieldFocused}
          />
          {activatedFormField === fieldName && (
            <CopyAssistButtonDropdown
              contentType={contentType}
              targetRef={copyAssistFormState?.[dataKey]?.formFieldRef}
              targetTagName={CopyAssistTagNames.InputWithNoTriggerIcon}
              fieldName={fieldName}
              value={getValues(fieldName)}
              setField={setValue}
              messageMedium={messageMedium}
              addSuggestionsAsVariants
            />
          )}
        </StyledCopyAssistWrapper>
      ) : (
        <ReadOnlyValue>{fieldValue}</ReadOnlyValue>
      )}
    </StyledVariantFormField>
  );
};
